webpackJsonp([7],{

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      id: this.$store.getters.user.id,
      name: this.$store.getters.user.name,
      email: this.$store.getters.user.email,
      photoURL: this.$store.getters.user.photoURL,
      bio: this.$store.getters.user.bio,
      contacts: this.$store.getters.user.contacts,
      file: null,
      title: this.$store.getters.user.title,
      organization: this.$store.getters.user.organization,
      projects: this.$store.getters.user.projects
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    confirmChanges: function confirmChanges() {
      var user = { id: this.id, name: this.name, email: this.email, photoURL: this.photoURL, bio: this.bio, contacts: this.contacts, title: this.title, organization: this.organization };
      this.$store.dispatch('editProfile', { user: user, file: this.file });
      this.$router.push('/profile/' + user.id);
    },
    imageSelected: function imageSelected(e) {
      this.file = e.target.files[0];
    }
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', [_c('form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('v-avatar', {
    attrs: {
      "size": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": this.photoURL,
      "alt": "avatar"
    }
  })])], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "selectedFile",
      "accept": "image/jpeg, image/png"
    },
    on: {
      "change": _vm.imageSelected
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Select a new profile image",
      "onclick": "document.getElementById('selectedFile').click();"
    }
  })])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "label": "Name",
      "id": "name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bio",
      "label": "Tell us a little about yourself",
      "id": "bio",
      "type": "bio",
      "required": ""
    },
    model: {
      value: (_vm.bio),
      callback: function($$v) {
        _vm.bio = $$v
      },
      expression: "bio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Job Title",
      "id": "title",
      "type": "title",
      "required": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "org",
      "label": "Organization",
      "id": "org",
      "type": "org",
      "required": ""
    },
    model: {
      value: (_vm.organization),
      callback: function($$v) {
        _vm.organization = $$v
      },
      expression: "organization"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.confirmChanges
    }
  }, [_vm._v("Confirm Changes")])], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.3aa4074aec83395f28d0.js